export default __webpack_public_path__ + "static/media/Nandyal-Diocese.452d58e3.png";